import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { ApiServiceService } from '../../api-service.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { EmailIdComponent } from '../email-id/email-id.component';

@Component({
  selector: 'ngx-ticket-view',
  templateUrl: './ticket-view.component.html',
  styleUrls: ['./ticket-view.component.scss']
})
export class TicketViewComponent implements OnInit {

  constructor(private ref:NbDialogRef<TicketViewComponent>,private api:ApiServiceService,private sanitizer: DomSanitizer,private dialogService: NbDialogService) { }
   @Input() data: any;
   ticketId: any;
   ticketHtml: any = '';
   loading: boolean = false;
   spinnerMainMsg: string = 'Loading Ticket Details...';
  ngOnInit(): void {
    this.ticketId = this.data.ticketId;
    console.log('Ticket Data:', this.data);
    console.log('Ticket ID:', this.ticketId);
    this.getTicketDetails();
  }




 getTicketDetails() {
  this.loading = true;
  this.api.ticketInvoiceHtmlView(this.ticketId).subscribe(
    (response: any) => {
      this.ticketHtml = this.sanitizer.bypassSecurityTrustHtml(response);
      this.loading = false;
    },
    (err) => {
      this.api.toastrSuccess('Something Went Wrong!!', 'Error');
      console.error('API Error:', err);
      this.loading = false;
    }
  );
}
  




  exportAsPdf() {
    this.api.toastrInfo('Please wait, generating PDF...', 'Info');
    this.api.ticketInvoicePdfExport(this.ticketId).subscribe((response: any) => {
      console.log('check Point', response);
      const contentDisposition = response.headers.get('Content-Disposition');

      const fileName = contentDisposition
        ? contentDisposition.split('filename=')[1].trim()
        : 'invoice.pdf';
      console.log('filename :', fileName);
      const blob = new Blob([response.body], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      this.api.toastrSuccess('Invoice Pdf Attachment Downloaded', 'Success');
    },
      (err) => {
        this.api.toastrSuccess('Something Went Wrong!!', 'Error');
        console.log('api errr',err);
      });
    }



     sendToMail() {
        const dialog = this.dialogService.open(
          EmailIdComponent, {
          context: {
            data: {
              heading: "Eamil Taxn Invoice",
            },
          },
          closeOnBackdropClick: false,
          closeOnEsc: false,
        }
        );
    
        dialog.onClose.subscribe(
          (res) => {
            console.log('check Point', res);
            if (res.status) {
              let payload={
                ticketId:this.ticketId,
                email:res.mail
              }
    
              this.api.ticketInvoiceToMail(payload).subscribe((response: any) => {
                console.log('check Point', response);
                this.api.toastrSuccess('Ticket invoice mailed successfully', 'Success');
             
              },
                (err) => {
                  this.api.toastrSuccess('Something Went Wrong!!', 'Error');
                  //console.log('api errr',err);
                });
            }
    
          },
          (err) => {
            console.log('check Point', err);
          }
        )
      }



  close() {
    this.ref.close();
  }
}
